import { UserController_Me } from '@/services/services';

/** The query key of the cached `/me` response that the session reads. */
export const ME_QUERY_KEY = [UserController_Me.key];

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

/** The cached `/me` response's user, or null when the cache holds no such shape. */
export function cachedUser(cache: unknown): Record<string, unknown> | null {
    if (!isRecord(cache) || !isRecord(cache.data) || !isRecord(cache.data.user)) return null;
    return { ...cache.data.user };
}

/** A cached profile field, or undefined when the cache holds no such field. */
export function cachedProfileField(cache: unknown, field: string): unknown {
    const profile = cachedUser(cache)?.profile;
    return isRecord(profile) && field in profile ? profile[field] : undefined;
}

/**
 * The cached `/me` response with one profile field set, every other field kept. A cache without
 * a user comes back unchanged.
 */
export function withCachedProfileField(cache: unknown, field: string, value: unknown): unknown {
    const user = cachedUser(cache);
    if (!user || !isRecord(cache) || !isRecord(cache.data)) return cache;
    const profile = isRecord(user.profile) ? user.profile : {};
    return {
        ...cache,
        data: { ...cache.data, user: { ...user, profile: { ...profile, [field]: value } } },
    };
}
